import { formatMoscowRelativeTimestamp } from '@/shared/lib/dateTime';
import { ActionButton } from '@/shared/ui/ActionButton/ActionButton';
import type { UserChatListProps } from '../model/types';
import { RequestStatus } from '@/shared/model/requestStatus';
import { RequestEmpty, RequestErrorBanner, RequestLoading } from '@/shared/ui/RequestState';
import classes from '@/entities/Chat/ui/ChatWorkspace.module.scss';

/** Показывает все диалоги выбранного пользователя */
export const UserChatList = (
    { owner, chats, status, error, selectedChatId, onSelect, onRetry, onMore, hasMore, loadingMore }: UserChatListProps
) => {
    return (
        <aside
            className={classes.chatListPanel}
            aria-label="Переписки пользователя"
        >
            <div className={classes.chatListHeader}>
                <h2>Диалоги{owner
                    ? ` · ${chats.length}`
                    : ''}</h2>
            </div>
            <div className={classes.chatListBody}>
                {!owner && (
                    <RequestEmpty message="Выберите пользователя, чтобы увидеть его переписки" />
                )}
                {status === RequestStatus.Loading && (
                    <RequestLoading message="Загружаем переписки..." />
                )}
                <RequestErrorBanner
                    status={status}
                    error={error}
                    fallbackMessage="Не удалось загрузить переписки"
                    onRetry={onRetry}
                />
                {status === RequestStatus.Success && chats.length === 0 && (
                    <RequestEmpty message="У пользователя пока нет переписок" />
                )}
                {status === RequestStatus.Success && (
                    <ul className={classes.chatItems}>
                        {chats.map((chat) => (
                            <li key={chat.id}>
                                <button
                                    type="button"
                                    className={`${classes.chatItem} ${chat.id === selectedChatId
                                        ? classes.chatItemSelected
                                        : ''}`}
                                    aria-current={chat.id === selectedChatId
                                        ? 'true'
                                        : undefined
                                    }
                                    onClick={() => onSelect(chat.id)}
                                >
                                    <span className={classes.chatItemContent}>
                                        <span className={classes.chatName}>{chat.companion.name}</span>
                                        <span className={classes.chatPreview}>{chat.companion.displayNameRole}</span>
                                        <span className={classes.chatPreviewRow}>
                                            <span className={classes.chatPreview}>
                                                {chat.lastMessage || (chat.lastMessageAt !== null
                                                    ? 'Сообщение или вложение'
                                                    : 'Нет сообщений')}
                                            </span>
                                            <time>{formatMoscowRelativeTimestamp(chat.lastMessageAt === null
                                                ? null
                                                : new Date(chat.lastMessageAt).toISOString())}</time>
                                        </span>
                                    </span>
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
                {hasMore &&
                    <ActionButton
                        type="button"
                        label="Ещё переписки"
                        color="secondary"
                        loading={loadingMore}
                        disabled={loadingMore}
                        onClick={onMore}
                    />
                }
            </div>
        </aside>
    );
};
